import { FaqItem } from '../../../shared/components/faq/faq.component';

/**
 * Questions on /info/healthy-wealthy-and-wise, emitted by `app-faq` as
 * FAQPage JSON-LD too, so plain text only.
 *
 * The method facts follow map-ai-backend: `MapAiIndex.ofRelativeToStateCountry`
 * (index = area score / state or US score), `HwwFormula` (the combined score
 * averages the available sub-indices) and `MapAiIndex.IndexLetterGrade`.
 */
export const HWW_FAQ: FaqItem[] = [
  {
    question: 'What is the Healthy, Wealthy and Wise index?',
    answer:
      'A Map AI score that summarizes how healthy, how economically secure ' +
      'and how educated the people of an area are. It combines three ' +
      'sub-indices - Health, Wealth and Education - and works for states, ' +
      'counties, cities and small areas down to a specific address.',
  },
  {
    question: 'What does an index of 1.0 mean?',
    answer:
      'That the area matches the average it is compared with. Every index is ' +
      'the area score divided by the same score for its state or for the ' +
      'whole US, so 1.2 means 20% above that average and 0.8 means 20% below.',
  },
  {
    question:
      'Should I compare a location against the US or against its state?',
    answer:
      'Use the US average to see how a location ranks nationally, for example ' +
      'when choosing between metro areas in different states. Use the state ' +
      'average to see how it stands out locally, among places that share the ' +
      'same state economy, laws and costs, so regional differences do not ' +
      'drown out the comparison.',
  },
  {
    question: 'How do I switch between national and state averages on the map?',
    answer:
      'On the main map, open the Area Summary section in the right panel and ' +
      'use the vs US / vs State switch; the map recolors right away. When the ' +
      'map shows whole states, only the national comparison applies.',
  },
  {
    question: 'What do the letter grades mean?',
    answer:
      'They make the scores easier to read at a glance, from F- to A+. C means ' +
      'about on par with the average, B and A better, D and F worse, and A+ ' +
      'and F- mark the far ends. Cut-offs are set per index, because health ' +
      'scores vary far less between areas than income does.',
  },
  {
    question: 'Where does the data behind the index come from?',
    answer:
      'From public sources: the U.S. Census Bureau American Community Survey ' +
      'for income, employment, homeownership, insurance coverage and ' +
      'education, the CDC for health conditions and behaviors, and the ' +
      'National Center for Health Statistics for life expectancy. The Data ' +
      'Sources page lists every dataset Map AI uses.',
  },
];
